export default __webpack_public_path__ + "static/media/1D.807aebf5.png";